import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import userService from '../services/usersService';

function PublicRoute() {
  const isAuthenticated = userService.isAuthenticated()
  return !isAuthenticated ? <Outlet /> : <Navigate to="/dashboard" />;
}

export default PublicRoute;